function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from "underscore";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import Button from "../elements/button";

var ModalFooterWithButtons = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalFooterWithButtons, _React$Component);

  var _super = _createSuper(ModalFooterWithButtons);

  function ModalFooterWithButtons() {
    var _this;

    _classCallCheck(this, ModalFooterWithButtons);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      if (_.isFunction(_this.props.onSubmit) && !_this.props.disableSave) {
        _this.props.onSubmit();

        if (_this.props.closeOnSubmit) {
          return _this.handleHide();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      if (!_this.props.disableCancel) {
        if (typeof _this.props.onCancel === "function") {
          _this.props.onCancel();
        }

        return _this.handleHide();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleHide", function () {
      return typeof _this.props.closeModal === "function" ? _this.props.closeModal() : undefined;
    });

    return _this;
  }

  _createClass(ModalFooterWithButtons, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("et--modal-footer-with-buttons", this.props.className)
      }, this.props.children ? /*#__PURE__*/React.createElement("div", {
        className: "et--modal-footer-with-buttons--children"
      }, this.props.children) : undefined, /*#__PURE__*/React.createElement("div", {
        className: "et--modal-footer-with-buttons--buttons"
      }, this.props.onCancel ? /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        disabled: this.props.disableCancel,
        className: "et--modal-footer-with-buttons--cancel",
        onClick: this.handleCancel
      }, this.props.cancelLabel) : undefined, this.props.onSubmit ? /*#__PURE__*/React.createElement(Button, {
        type: this.props.type,
        disabled: this.props.disableSave,
        onClick: this.handleSubmit,
        className: "et--modal-footer-with-buttons--submit"
      }, this.props.saveLabel) : undefined), this.props.rightChildren && /*#__PURE__*/React.createElement("div", {
        className: "et--modal-footer-with-buttons--children"
      }, this.props.rightChildren));
    }
  }]);

  return ModalFooterWithButtons;
}(React.Component);

_defineProperty(ModalFooterWithButtons, "displayName", "ModalFooterWithButtons");

_defineProperty(ModalFooterWithButtons, "propTypes", {
  className: PropTypes.string,
  type: PropTypes.string,
  saveLabel: PropTypes.any,
  cancelLabel: PropTypes.any,
  disableSave: PropTypes.bool,
  disableCancel: PropTypes.bool,
  closeOnSubmit: PropTypes.bool,
  closeModal: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  rightChildren: PropTypes.any
});

_defineProperty(ModalFooterWithButtons, "defaultProps", {
  type: "default",
  saveLabel: "Save",
  cancelLabel: "Cancel",
  closeOnSubmit: true
});

export { ModalFooterWithButtons as default };